import React, {useEffect, useState} from 'react';
import {useDispatch} from "react-redux";
import {getData} from "../../../actions/data";
import {useNavigate, useParams} from "react-router-dom";
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';

interface OrderMainFoodProductListProps {
    selectedCategory: string;
    setSelectedCategory: (category: string) => void;
    categories: string[],
}

const sortOptions = [
    { value: 'Ascending price', label: 'Ascending price' },
    { value: 'Descending price', label: 'Descending price' },
    { value: 'Novelty', label: 'Novelty' },
    { value: 'Popularity', label: 'Popularity' },
    { value: 'Discount', label: 'Discount' },
    { value: 'Nearest time', label: 'Nearest time' },
    { value: 'Nearest locations', label: 'Nearest locations' },
];

const OrderMainFoodCategory: React.FC<OrderMainFoodProductListProps> = (props: OrderMainFoodProductListProps) => {
    const { category } = useParams();
    const [selectedCategory, setSelectedCategory] = useState<string>(props.selectedCategory);
    //const [categories, setCategories] = useState<string[]>([]);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [selectedMoreCategory, setSelectedMoreCategory] = useState<string>("");
    const [sortedBy, setSortedBy] = useState<string>("");
    
    /* const addItemToCategory = (item: any) => {
        setCategories(prevCategories => {
            if (!prevCategories.includes(item)) {
                return [...prevCategories, item];
            }
            return prevCategories;
        });
    } */

    const handleShowItemDetails = (categoryTmp: string) => () => {
        navigate(`/food/${categoryTmp}`);
    }

    useEffect(() => {
        console.log("OrderMainFoodCategory selectedCategory: ", selectedCategory);
        const fetchData = async () => {
            try {
                //const response = await getData(dispatch);
                //if (response) {
                //    response.forEach((item: any) => {
                //        //addItemToCategory(item.category);
                //    });
                //    console.log("response category: ", response);
                //}
                
                if (!props.selectedCategory && category) {
                    setSelectedCategory(`${category}`);
                }
            }
            catch (error) {
                console.log(error);
            }
        }
        fetchData().then();
    }, [dispatch, category, props.selectedCategory]);

    // @ts-ignore
    return (
        <div className="orderMainFoodCategory__container">
            <div className="orderMainFoodCategory__container-wrap">
                <div className="orderMainFoodCategory__container-categories">
                    <div
                        className={`orderMainFoodCategory__container-category all 
                        ${selectedCategory === "All" ? 'active' : ''}
                        ${category === "all" ? 'active' : ''}
                        `}
                        onClick={() => {
                            props.setSelectedCategory("All");
                            setSelectedCategory("All");
                            handleShowItemDetails("all");
                            setSelectedMoreCategory("");
                            navigate(``);
                        }}
                    >
                        <span>All</span>
                    </div>
                    <div
                        className={`orderMainFoodCategory__container-category take-out 
                        ${selectedCategory === "Take-out" ? 'active' : ''}
                        ${category === "take-out" ? 'active' : ''}
                        `}
                        onClick={() =>
                        {
                            props.setSelectedCategory("Take-out");
                            setSelectedCategory("Take-out");
                            handleShowItemDetails("take-out");
                            navigate(`take-out`);
                        }}
                    >
                        <span>Take-out</span>
                    </div>
                    <div
                        className={`orderMainFoodCategory__container-category dine-in 
                        ${selectedCategory === "Dine-in" ? 'active' : ''}
                        ${category === "dine-in" ? 'active' : ''}
                        `}
                        onClick={() => {
                            props.setSelectedCategory("Dine-in");
                            setSelectedCategory("Dine-in");
                            handleShowItemDetails("dine-in");
                            navigate(`dine-in`);
                        }}
                    >
                        <span>Dine-in</span>
                    </div>
                    <div className="orderMainFoodCategory__container-categories-items-wrap">
                        {
                            props.categories.slice(0,2).map((item: any, index: number) => {
                                return (
                                    <div
                                        className={`orderMainFoodCategory__container-category item
                                        ${selectedCategory === item/*.toLowerCase().replace(/\s/g, "-")*/ ? 'active' : ''}
                                        ${category === item.toLowerCase().replace(/\s/g, "-") ? 'active' : ''}
                                        `}
                                        key={index}
                                        onClick={() => {
                                            setSelectedMoreCategory("");
                                            props.setSelectedCategory(item)
                                            setSelectedCategory(item);
                                            handleShowItemDetails(item.toLowerCase().replace(/\s/g, "-"));
                                            navigate(`${item.toLowerCase().replace(/\s/g, "-")}`);
                                        }}
                                    >
                                        <span>{item}</span>
                                    </div>
                                );
                            })
                        }
                    </div>
                    <div className="orderMainFoodCategory__container-category dropdown">
                        <Dropdown
                            className={`orderMainFoodCategory__container-category-dropdown
                                ${selectedMoreCategory !== "" ? 'active' : ''}
                            `}
                            arrowClosed={
                                <div className="orderMainFoodCategory__container-category-dropdown-icon close">
                                    <img src={process.env.PUBLIC_URL + "/images/close-arrow-icon.svg"} alt="arrow closed"/>
                                </div>
                            }
                            arrowOpen={
                                <div className="orderMainFoodCategory__container-category-dropdown-icon open">
                                    <img src={process.env.PUBLIC_URL + "/images/close-arrow-icon.svg"} alt="arrow open"/>
                                </div>
                            }
                            options={[
                                { value: "take-out", label: "Take-out" },
                                { value: "dine-in", label: "Dine-in" },
                                ...props.categories
                            ]}
                            onChange={(e) => {
                                setSelectedMoreCategory(e.value);
                                props.setSelectedCategory(e.value);
                                setSelectedCategory(e.value);
                                handleShowItemDetails(e.value.toLowerCase().replace(/\s/g, "-"));
                                navigate(`${e.value.toLowerCase().replace(/\s/g, "-")}`);
                            }}
                            value={selectedMoreCategory === "" ? "More" : selectedMoreCategory}
                        />
                    </div>
                </div>
                <div className="orderMainFoodCategory__container-sort-wrap dropdown">
                    <Dropdown
                        className={`orderMainFoodCategory__container-sort-dropdown
                            ${sortedBy !== "" ? 'active' : ''}
                            `}
                        arrowClosed={
                            <div className="orderMainFoodCategory__container-sort-icon">
                                <img
                                    src={process.env.PUBLIC_URL + "/images/sort-arrow-up.svg"}
                                    alt="sort up icon"
                                />
                                <img
                                    src={process.env.PUBLIC_URL + "/images/sort-arrow-down.svg"}
                                    alt="sort down icon"
                                />
                            </div>
                        }
                        arrowOpen={
                            <div className="orderMainFoodCategory__container-sort-icon">
                                <img
                                    src={process.env.PUBLIC_URL + "/images/sort-arrow-up.svg"}
                                    alt="sort up icon"
                                />
                                <img
                                    src={process.env.PUBLIC_URL + "/images/sort-arrow-down.svg"}
                                    alt="sort down icon"
                                />
                            </div>
                        }
                        options={sortOptions}
                        onChange={(e) => {
                            setSortedBy(e.value);
                            //setSelectedMoreCategory(e.value);
                            //selectCategory(e.value);
                            //setSelectedCategory(e.value);
                            //handleShowItemDetails(e.value.toLowerCase().replace(/\s/g, "-"));
                            //navigate(`${e.value.toLowerCase().replace(/\s/g, "-")}`);
                        }}
                        value={sortedBy === "" ? "Sort" : sortedBy}
                    />
                </div>
            </div>
        </div>
    );
};

export default OrderMainFoodCategory;